import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Volume2 } from "react-feather";
import { actionCreators as participantsActions } from "../../../state/ducks/participants";
import { classNames } from "../../../utils/common";

function MuteAll({ className, iconStyle }) {
  const [buttonClicked, setButtonClicked] = useState(false);
  const label = "Mute All";
  const dispatch = useDispatch();

  const allParticipants = useSelector((state) => state.participants);

  const muteAllParticipants = (allParticipants, dispatch) => {
    setButtonClicked(!buttonClicked);
    Object.values(allParticipants).map((data) => {
      if (!data.isPublisher && data.audio) {
        dispatch(participantsActions.toggleAudio(data.id));
      }
    });
  };

  return (
    <button
      title={"Mute All"}
      aria-label={label}
      className={className}
      onClick={() => muteAllParticipants(allParticipants, dispatch)}
    >
      <Volume2 className={classNames("text-secondary", iconStyle)} />
    </button>
  );
}

export default MuteAll;
